import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const MoreHorizontal = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path d="M12.66 4h-1.33a1.1 1.1 0 0 0-1.1 1.1v1.33a1.1 1.1 0 0 0 1.1 1.1h1.33a1.1 1.1 0 0 0 1.1-1.1V5.1a1.1 1.1 0 0 0-1.1-1.1ZM12.66 10.23h-1.33a1.1 1.1 0 0 0-1.1 1.1v1.33a1.1 1.1 0 0 0 1.1 1.1h1.33a1.1 1.1 0 0 0 1.1-1.1v-1.33a1.1 1.1 0 0 0-1.1-1.1ZM12.66 16.47h-1.33a1.1 1.1 0 0 0-1.1 1.1v1.33a1.1 1.1 0 0 0 1.1 1.1h1.33a1.1 1.1 0 0 0 1.1-1.1v-1.33a1.1 1.1 0 0 0-1.1-1.1Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default MoreHorizontal
